import { useMutation } from '@gogame/query';

import { createSharedAccountPartnerAudience } from 'scenes/CustomAudiences/PartnerAudiences/sources/sharedAccounts';

import { createSharedAccounts } from '../queryKeyFactory';

export const useCreateSharedAccountsPA = () => {
  const createSharedaccountsMutation = useMutation(
    createSharedAccounts(),
    createSharedAccountPartnerAudience,
    {
      successMessage: () => `Partner Audience shared`,
    }
  );

  const handleAction = async params => {
    await createSharedaccountsMutation.mutateAsync(params);
  };

  return [handleAction, createSharedaccountsMutation];
};
